import type {ReactElement} from 'react';
import {CSSTransition} from 'react-transition-group';
import type {TransitionProps} from '@interfaces/transition';
import styles from './quickFade.module.scss';

export default function QuickFade(props: TransitionProps): ReactElement<TransitionProps> {
    return (
        <CSSTransition
            {...props}
            classNames={{
                enter: styles.enter,
                enterActive: styles.enterActive,
                exitActive: styles.exitActive,
            }}
            timeout={100}
        />
    );
}
